export default __webpack_public_path__ + "static/media/no-interest-statements-product.f857e97e.svg";